// @ts-nocheck

import { classNames } from '@core/utils/functions/class-names';

// eslint-disable-next-line import/prefer-default-export
export function Container({ className, children, ...props }) {
    return (
        <div className={classNames('lg:px-8', className)} {...props}>
            <div className="w-full lg:max-w-4xl">
                <div className="mx-auto px-4 sm:px-6 md:max-w-2xl md:px-4 lg:px-0">{children}</div>
            </div>
        </div>
    );
}
